module.exports = __webpack_public_path__ + "img/choose_receipt2.bcf0c0e1.png";